import { useEffect } from "react";

const GHLWidget = () => {
  useEffect(() => {
    // Prevent loading it twice
    if (document.getElementById("ghl-chat-widget")) return;

    const script = document.createElement("script");

    script.id = "ghl-chat-widget";
    script.src = "https://widgets.leadconnectorhq.com/loader.js";
    script.async = true;

    script.setAttribute(
      "data-resources-url",
      "https://widgets.leadconnectorhq.com/chat-widget/loader.js"
    );

    script.setAttribute(
      "data-widget-id",
      "6a4fbcf0f5424a5002432981"
    );

    script.setAttribute(
      "data-source",
      "WEB_USER"
    );

    document.body.appendChild(script);

    return () => {
      script.remove();

      // Remove the widget when leaving the homepage
      document
        .querySelectorAll(
          'iframe[src*="leadconnectorhq"], iframe[src*="chat-widget"], [id*="chat-widget"], [class*="chat-widget"]'
        )
        .forEach((el) => el.remove());
    };
  }, []);

  return null;
};

export default GHLWidget;